import { Component, Input } from '@angular/core';
import { AppModuleCode } from 'src/core/interfaces/modules.interfaces';

@Component({
  selector: 'tab',
  imports: [],
  templateUrl: './tab.component.html',
  standalone: true,
})
export class TabComponent {
  @Input() label!: string;
  @Input() name!: string;
  @Input() module?: AppModuleCode;
  active = false;
}